import { Dispatch } from "redux";
import { InputUser, SignUpAction, GetUsersAction, InputLogin } from '../Interfaces/Interfaces'
import axios from "axios";
import Swal from "sweetalert2";

const ruta = process.env.REACT_APP_API || "http://localhost:3001/"

/* interface InputNuevoTurno {
  date: string;
  initTime: string;
  endTime: string;
} */


export interface SignUpThunkAction {
  (dispatch: Dispatch<SignUpAction>): Promise<void>;
}

export function SignUp(inputUser: InputUser): any {
  return async function (dispatch: Dispatch<SignUpAction>) {
    try {
      let response = await axios.post(
        `${ruta}postUser`,
        inputUser
      );
      localStorage.token = response.data.token;
      localStorage.rol = response.data.usuario
      dispatch({ type: "SIGN_UP", payload: response.data });
    } catch (e) {
      Swal.fire({
        title: 'Hubo un error al crear la cuenta, intentelo nuevamente',
        icon: 'error',
        timer: 1500,
        timerProgressBar: true,
        showConfirmButton: false
      })
    }
  };
}

export function getUsers(token:any): any {
  return async function (dispatch: Dispatch<GetUsersAction>) {
    try {
      let response = await axios.get(`${ruta}getUsers` ,
      {headers:{"token":token}}
      );
      dispatch({ type: 'GET_USERS', payload: response.data });
    } catch (e) {
      console.log(e);
    }
  };
}
export function getContador():any {
  return async function (dispatch: Dispatch<GetUsersAction>) {
    try {
      let response = await axios.get(`${ruta}getContador` ,
      );
      dispatch({ type: 'GET_CONTADOR', payload: response.data });
    } catch (e) {
      console.log(e);
    }
  };
}

export function getDDJJ(userId: any, token: any): any {
  return async function (dispatch: Dispatch<GetUsersAction>) {
    try {
      let response = await axios.get(`${ruta}getDDJJ?userId=${userId}`, {headers:{"token":token}});
      dispatch({ type: 'GET_DDJJ', payload: response.data });
    } catch (e) {
      console.log(e);
    }
  };
}
export function getDDJJUser( token: any): any {
  return async function (dispatch: Dispatch<GetUsersAction>) {
    try {
      let response = await axios.get(`${ruta}getDDJJUser`, {headers:{"token":token}});
      dispatch({ type: 'GET_DDJJ_USER', payload: response.data });
    } catch (e) {
      console.log(e);
    }
  };
}




export function getDocDDJJ(userId: any, token: any): any {
  return async function (dispatch: Dispatch<GetUsersAction>) {
    try {
      let response = await axios.get(`${ruta}getDDJJ?userId=${userId}`, {headers:{"token":token}});
      dispatch({ type: 'GET_DDJJ', payload: response.data });
    } catch (e) {
      console.log(e);
    }
  };
}

export function getUserInfo(token: any,id:any): any {
  return async function (dispatch: Dispatch<GetUsersAction>) {
    try {
      let response = await axios.get(`${ruta}getUserInfo?userId=${id}`, {headers:{"token":token}});
      dispatch({ type: 'GET_USER_INFO', payload: response.data });
    } catch (e) {
      console.log(e);
    }
  };
}

export function getMyTurnos(token: any): any {
  return async function (dispatch: Dispatch<GetUsersAction>) {
    try {

      let response = await axios.get(`${ruta}getMyTurnosss`,
      {headers:{"token":token}}
      );
      dispatch({ type: 'GET_MYTURNOS', payload: response.data });
    } catch (e) {
      console.log(e);
    }
  };
}

export function GetTurnos(doctorId: number): any {
  return async function (dispatch: Dispatch<SignUpAction>) {
    try {
      let response = await axios.get(
        `${ruta}getTurnosByDoctor?doctorId=${doctorId}`,
        /* {headers:{"token":token}} */
      );
      dispatch({ type: "GET_TURNOS", payload: response.data });
    } catch (e) {
      console.log(e);
    }
  };
}

export function SelectTurno(turnoId: number): any {
  return async function (dispatch: Dispatch<SignUpAction>) {
    try {

      let response = await axios.put(
        `${ruta}selectTurno?turnoId=${turnoId}&userId=1`,
        /* {headers:{"token":token}} */
      );
      dispatch({ type: "SELECT_TURNO", payload: response.data });
    } catch (e) {
      console.log(e);
    }
  };
}
export function CancelTurno(turnoId: number): any {
  return async function (dispatch: Dispatch<SignUpAction>) {
    try {

      let response = await axios.delete(
        `${ruta}cancelTurno?turnoId=${turnoId}&userId=1`,
        /* {headers:{"token":token}} */
      );
      dispatch({ type: "CANCEL_TURNO", payload: response.data });
    } catch (e) {
      console.log(e);
    }
  };
}



export function SignIn(input: InputLogin): any {
  return async function (dispatch: Dispatch<SignUpAction>) {
    try {
      let response = await axios.post(
        `${ruta}verifylogin`,
         input
      );

      localStorage.token = response.data.token;
      localStorage.rol = response.data.usuario
      dispatch({ type: "SIGN_IN", payload: response.data });
    } catch (e) {
      console.log(e);
    }
  };
}

export function CreateTurno(input: any, token:any): any {
  return async function (dispatch: Dispatch<SignUpAction>) {
    try {
      let response = await axios.post(
        `${ruta}postTurno`,
        input,
        {headers:{"token":token}}
         );

      dispatch({ type: "CREATE_TURNO", payload: response.data });
    } catch (e) {
      console.log(e);
    }
  };
}

export function PostDDJJ(input:any, inputTutor:any, token:any): any {
  return async function (dispatch: Dispatch<SignUpAction>) {
    try {
      let response = await axios.post(
        `${ruta}postDDJJ`,
        { input, inputTutor },
        { headers: { "token": token } }
      );
      dispatch({ type: "POST_DDJJ", payload: response.data });
    } catch (e) {
      console.log(e);
    }
  };
}

export function PostConsentimiento(input:any, token:any): any {
  return async function (dispatch: Dispatch<SignUpAction>) {
    try {
      let response = await axios.post(
        `${ruta}postConsentimiento`,
        { input },
        { headers: { "token": token } }
      );

      dispatch({ type: "POST_CONSENTIMIENTO", payload: response.data });
    } catch (e) {
      console.log(e);
    }
  };
}
export function PostConsentimientoNuevo(input:any, token:any): any {
  return async function (dispatch: Dispatch<SignUpAction>) {
    try {
      let response = await axios.post(
        `${ruta}postConsentimientoNuevo`,
        { input },
        { headers: { "token": token } }
      );
      dispatch({ type: "POST_CONSENTIMIENTO_NUEVO", payload: response.data });
    } catch (e) {
      console.log(e);
    }
  };
}

export function PostDDJJRenovacion(input:any, inputTutor:any, token:any): any {
  return async function (dispatch: Dispatch<SignUpAction>) {
    try {
      
      let response = await axios.post(
        `${ruta}postDDJJNuevo`,
        { input, inputTutor },
        { headers: { "token": token } }
      );
      dispatch({ type: "POST_DDJJ_RENOVACION", payload: response.data });
    } catch (e) {
      console.log(e);
    }
  };
}



export function PostDocDDJJ(input:any,userId:any, token:any): any {
  return async function (dispatch: Dispatch<SignUpAction>) {
    try {
      let response = await axios.post(
        `${ruta}postDJDOC?userId=${userId}`,
        { input },
        { headers: { "token": token } }
      );

      dispatch({ type: "POST_DDJJ_DOC", payload: response.data });
    } catch (e) {
      console.log(e);
    }
  };
}
export function PostDocDDJJNuevo(input:any,userId:any, token:any): any {
  return async function (dispatch: Dispatch<SignUpAction>) {
    try {
      let response = await axios.post(
        `${ruta}postDJDOCNuevo?userId=${userId}`,
        { input },
        { headers: { "token": token } }
      );
      dispatch({ type: "POST_DDJJ_DOC", payload: response.data });
    } catch (e) {
      console.log(e);
    }
  };
}

export function PostAnexoDoc(input:any,userId:any, token:any): any {
  return async function (dispatch: Dispatch<SignUpAction>) {
    try {
      let response = await axios.post(
        `${ruta}postAnexoDoc?userId=${userId}`,
        { input },
        { headers: { "token": token } }
      );
      dispatch({ type: "POST_ANEXO_DOC", payload: response.data });
    } catch (e) {
      console.log(e);
    }
  };
}


export function PostAnexoDocRenovado(input:any,userId:any, token:any): any {
  return async function (dispatch: Dispatch<SignUpAction>) {
    try {
      let response = await axios.post(
        `${ruta}postAnexoDocNuevo?userId=${userId}`,
        { input },
        { headers: { "token": token } }
      );
      dispatch({ type: "POST_ANEXO_DOC", payload: response.data });
    } catch (e) {
      console.log(e);
    }
  };
}



export function RecuperarContraseña(input:any): any {
  return async function (dispatch: Dispatch<SignUpAction>) {
    try {
      
      let response = await axios.post(
        `${ruta}recuperarContrasena`,input
      );
      Swal.fire({
        icon: 'success',
        title: `${response.data.messagge}`,
      });
      dispatch({ type: "RECUPERAR_CONTRASENA", payload: response.data });
    } catch (error:any) {
      Swal.fire({
        icon: 'error',
        title: `${error.response.data.messagge}`,
      });
      console.log(error);
    }
  };
}


export function getAnexoDoc(userId:any,token:any): any{
  return async function(dispatch: Dispatch<SignUpAction>) {
    try {
      const json = await axios.get(`${ruta}getAnexoDoc?userId=${userId}`,{ headers: { "token": token } });
      dispatch({
        type: 'GET_ANEXO_DOC',
        payload: json.data,
      });
    } catch (error) {
      console.log(error);
    }
  };
}
export function getConsentimientoUsuario(userId:any,token:any): any{
  return async function(dispatch: Dispatch<SignUpAction>) {
    try {
      const json = await axios.get(`${ruta}getConsentimientoUser?userId=${userId}`,{ headers: { "token": token } });
      dispatch({
        type: 'GET_CONSENTIMIENTO_USUARIO',
        payload: json.data,
      });
    } catch (error) {
      console.log(error);
    }
  };
}
export function getConsentimientoUsuarioNuevo(userId:any,token:any): any{
  return async function(dispatch: Dispatch<SignUpAction>) {
    try {
      const json = await axios.get(`${ruta}getConsentimientoUserNuevo?userId=${userId}`,{ headers: { "token": token } });
      dispatch({
        type: 'GET_CONSENTIMIENTO_USUARIO_NUEVO',
        payload: json.data,
      });
    } catch (error) {
      console.log(error);
    }
  };
}
export function getConsentimiento(token:any): any{
  return async function(dispatch: Dispatch<SignUpAction>) {
    try {
      const json = await axios.get(`${ruta}getConsentimiento`,{ headers: { "token": token } });
      dispatch({
        type: 'GET_CONSENTIMIENTO',
        payload: json.data,
      });
    } catch (error) {
      console.log(error);
    }
  };
}
export function getConsentimientoNuevo(token:any): any{
  return async function(dispatch: Dispatch<SignUpAction>) {
    try {
      const json = await axios.get(`${ruta}getConsentimientoNuevo`,{ headers: { "token": token } })
      dispatch({
        type: 'GET_CONSENTIMIENTO_NUEVO',
        payload: json.data,
      });
    } catch (error) {
      console.log(error);
    }
  };
}


export function getAnexoDocRenovado(userId:any,token:any): any{
  return async function(dispatch: Dispatch<SignUpAction>) {
    try {
     
      const json = await axios.get(`${ruta}getAnexoDocNuevo?userId=${userId}`,{ headers: { "token": token } });
      dispatch({
        type: 'GET_ANEXO_DOC_NUEVO',
        payload: json.data,
      });
    } catch (error) {
      console.log(error);
    }
  };
}


export function getAnexoUser(token:any): any{
  return async function(dispatch: Dispatch<SignUpAction>) {
    try {
      const json = await axios.get(`${ruta}getAnexoUser`,{ headers: { "token": token } });
      dispatch({
        type: 'GET_ANEXO_USER',
        payload: json.data,
      });
    } catch (error) {
      console.log(error);
    }
  };
}
export function getUsersByDNI(payload: any,token:any): any{
  return async function(dispatch: Dispatch<SignUpAction>) {
    try {
      const json = await axios.get(`${ruta}getUsersByDNI?search=${payload}`,{
        headers: { 'token': token }
      });
      dispatch({
        type: 'GET_USERS_DNI',
        payload: json.data,
      });      
    } catch (error) {
      console.log(error);
    }
  };
}


export function getTurnosDisponibles(date: string): any{
  console.log(date)
  return async function(dispatch: Dispatch<SignUpAction>) {
    try {
      const json = await axios.get(`${ruta}getTurnosDisponibles?doctorId=1&fecha=${date}`);
      dispatch({
        type: 'TURNOS_DISPONIBLES',
        payload: json.data,
      });
    } catch (error) {
      console.log(error);
    }
  };
}

export function getDetail(id: number): any{
  return async function(dispatch: Dispatch<SignUpAction>){
    try {
      var json=await axios.get(`${ruta}getUserById?id=${id}`)  
      return dispatch({
        type: 'GET_DETAIL',
        payload: json.data
      })
    } catch (error) {
      console.log(error)
    }
  }
}


export function pagarTurno(): any{
  return async function(dispatch: Dispatch<SignUpAction>){
    try {
      var json=await axios.get(`${ruta}pagos`)  
      return dispatch({
        type: 'GET_PAGO',
        payload: json.data
      })
    } catch (error) {
      console.log(error)
    }
  }
}

export function switchStatus(turnoId:any): any{
  return async function(dispatch: Dispatch<SignUpAction>){
    try {
      var json=await axios.put(`${ruta}switchStatus?turnoId=${turnoId}`)  
      return dispatch({
        type: 'PUT_STATUS',
        payload: json.data
      })
    } catch (error) {
      console.log(error)
    }
  }
}
export function putContador():any{
  return async function(dispatch: Dispatch<SignUpAction>){
    try {
      var json=await axios.put(`${ruta}sumarContador`)  
      return dispatch({
        type: 'PUT_CONTADOR',
        payload: json.data
      })
    } catch (error) {
      console.log(error)
    }
  }
}
export function updatePassword(input: any, token: any): any {
  return async function (dispatch: Dispatch<SignUpAction>) {
    try {
      const json = await axios.put(`${ruta}updatePassword`, input, {
        headers: { 'token': token }
      });
      Swal.fire({
        icon: 'success',
        title: `${json.data.messagge}`,
      });
      return dispatch({
        type: 'UPDATE_PASSWORD',
        payload: json.data,
      });
    } catch (error: any) {
      console.log(error)
      Swal.fire({
        icon: 'error',
        title: `${error.response.data.messagge}`,
      });
    }
  };
}

export function switchPaymentStatus(turnoId:any): any{
  return async function(dispatch: Dispatch<SignUpAction>){
    try {
      var json=await axios.put(`${ruta}switchPaymentStatus?turnoId=${turnoId}`)  
      return dispatch({
        type: 'PUT_PAYMENTSTATUS',
        payload: json.data
      })
    } catch (error) {
      console.log(error)
    }
  }
}



export function changeMetod(titular:any): any{
  return async function(dispatch: Dispatch<SignUpAction>){
    try {
      console.log(titular)
      var json=await axios.put(`${ruta}activeCard`, titular)  
      return dispatch({
        type: 'ACTIVE_METHOD',
        payload: json.data
      })
    } catch (error) {
      console.log(error)
    }
  }
}


export function getDDJJNuevo(userId: any, token: any): any {
  return async function (dispatch: Dispatch<GetUsersAction>) {
    try {
      let response = await axios.get(`${ruta}getDDJJNuevo?userId=${userId}`, {headers:{"token":token}});
      dispatch({ type: 'GET_DDJJ_NUEVO', payload: response.data });
    } catch (e) {
      console.log(e);
    }
  };
}

export function getDDJJUserNuevo(token: any): any {
  return async function (dispatch: Dispatch<GetUsersAction>) {
    try {
      let response = await axios.get(`${ruta}getDDJJUserNuevo`, {headers:{"token":token}});
      dispatch({ type: 'GET_DDJJ_USER_NUEVO', payload: response.data });
    } catch (e) {
      console.log(e);
    }
  };
}


export function getCard(): any{
  return async function(dispatch: Dispatch<SignUpAction>){
    try {
      var json=await axios.get(`${ruta}getCard`)  
      return dispatch({
        type: 'PAYMENT_METHOD',
        payload: json.data
      })
    } catch (error) {
      console.log(error)
    }
  }
}
export function getComment(userId:any,token:any): any{
  return async function(dispatch: Dispatch<SignUpAction>){
    try {
      var json=await axios.get(`${ruta}getComment?userId=${userId}`, {headers:{"token":token}})  
      return dispatch({
        type: 'GET_COMMENT',
        payload: json.data
      })
    } catch (error) {
      console.log(error)
    }
  }
}

export function putComment(token:any,comentarioId:any,input:any ): any{
  return async function(dispatch: Dispatch<SignUpAction>){
    try {
      var json=await axios.put(`${ruta}putComment?comentarioId=${comentarioId}`,input,{headers:{"token":token}})  
      return dispatch({
        type: 'PUT_COMMENT',
        payload: json.data
      })
    } catch (error) {
      console.log(error)
    }
  }
}

export function SacarTurno(input:any, token:any): any {
  return async function (dispatch: Dispatch<SignUpAction>) {
    try {
      let response = await axios.post(
        `${ruta}sacarTurno`,
        { input },
        { headers: { "token": token } }
      );
      dispatch({ type: "SACAR_TURNO", payload: response.data });
    } catch (e) {
      console.log(e);
    }
  };
}

export function SacarTurnosDelDia(input:any, token:any): any {
  return async function (dispatch: Dispatch<SignUpAction>) {
    try {
      let response = await axios.post(
        `${ruta}sacarTurnosDelDia`,
        { date:input },
        { headers: { "token": token } }
      );
      dispatch({ type: "SACAR_TURNOS_DEL_DIA", payload: response.data });
    } catch (e) {
      console.log(e);
    }
  };
}


export function RestablecerTurnos(date:any, token:any): any {
  return async function (dispatch: Dispatch<SignUpAction>) {
    try {
      let response = await axios.delete(
        `${ruta}restablecerTurnos?date=${date}`,
        { headers: { "token": token }}
      );
      dispatch({ type: "SACAR_TURNOS_DEL_DIA", payload: response.data });
    } catch (e) {
      console.log(e);
    }
  };
}